module.exports = __webpack_public_path__ + "img/Auth.7c79e694.svg";